import __request__ from "routing/request";
export function aggregateSearchRequestSpec(searchRequestSpec, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/search/aggregate", searchRequestSpec, {}, {
    "Accept": []
  }, requestOptions);
}
export function aggregateForQueryParameters(query, streams, stream_categories, timerange, groups, metrics, size, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/search/aggregate", null, { "query": query, "streams": streams, "stream_categories": stream_categories, "timerange": timerange, "groups": groups, "metrics": metrics, "size": size }, {
    "Accept": []
  }, requestOptions);
}
export function messagesByQueryRequestSpec(queryRequestSpec, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/search/messages", queryRequestSpec, {}, {
    "Accept": []
  }, requestOptions);
}
export function messagesByQueryParameters(query, timerange, streams, stream_categories, fields, sort, sortOrder, from, size, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/search/messages", null, { "query": query, "streams": streams, "stream_categories": stream_categories, "timerange": timerange, "fields": fields, "sort": sort, "sortOrder": sortOrder, "from": from, "size": size }, {
    "Accept": []
  }, requestOptions);
}
